var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrowTop",on:{"click":_vm.toTop}},[_c('div',[_c('img',{attrs:{"src":(_vm.imgPath + "/static/assets/img/arrow_top.png")}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('top')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0c9ad65a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/top.vue
// module id = null
// module chunks = 